// removed by extract-text-webpack-plugin
module.exports = {"block":"alert__block-2RO9k","icon":"alert__icon-1Ky4f","check":"alert__check-1wZxo","link":"alert__link-31-fW","title":"alert__title-15a0P","text":"alert__text-2Yr8D","redirect":"alert__redirect-26TKQ"};


//////////////////
// WEBPACK FOOTER
// ./components/auth/alert/alert.css
// module id = 786
// module chunks = 0